function createBangleJSUiCode(x, y, z, renderBox, name, width, text, lineCount, fontSize, textAlignment, fitText) {
  return {
    active: true,
    name,
    text: `${text}`,
    x,
    y,
    z,
    renderBoxTlX: renderBox.tl.x,
    renderBoxTlY: renderBox.tl.y,
    renderBoxBrX: renderBox.br.x,
    renderBoxBrY: renderBox.br.y,
    lineCount,
    width,
    fontSize,
    textAlignment,
    fitText,
    render: function () {
      if (!this.active) return;
      let activeFontSize = this.fontSize;
      g.setFontVector(activeFontSize);

      if (this.fitText) {
        let overallLength = g.stringWidth(this.text);
        while (overallLength / this.lineCount > this.width && activeFontSize > 0) {
          activeFontSize -= 1;
          g.setFontVector(activeFontSize);
          overallLength = g.stringWidth(this.text);
        }
        if (activeFontSize === 0) {
          g.setFontVector(activeFontSize);
        }
      }

      let lines = [];
      let currentLine = '';

      for (let i = 0; i < this.text.length; i++) {
        if (g.stringWidth(currentLine) > this.width) {
          lines.push(currentLine);
          currentLine = this.text[i];
        } else {
          currentLine += this.text[i];
        }
      }
      if (currentLine.length !== 0) {
        lines.push(currentLine);
      }

      lines = lines.splice(0, this.lineCount);
      for (let i = 0; i < lines.length; i++) {
        let alignmentOffset = 0;
        if (this.textAlignment === 'CENTER') {
          alignmentOffset = this.width / 2 - g.stringWidth(lines[i]) / 2;
        }
        g.drawString(lines[i], this.x + alignmentOffset, this.y + (this.fontSize - activeFontSize) / 2 + this.fontSize * i, true);
      }
    },
  }
}

module.exports = {
  createBangleJSUiCode,
}
